import { Link } from 'react-router-dom';

const reviews = [
  {
    name: 'Michael T.',
    location: 'Summerlin, NV',
    rating: 5,
    text: 'Quinolux installed a frameless shower door in our master bath and it looks absolutely stunning. The craftsmanship is flawless — no gaps, perfect seal, and the hardware is top quality. Highly recommend!',
    project: 'Frameless Shower Door',
    avatar: 'https://public.readdy.ai/ai/img_res/f1a61575a833b5249952661b69c71d10.jpg',
  },
  {
    name: 'Sarah K.',
    location: 'Henderson, NV',
    rating: 5,
    text: 'We had glass railings installed on our staircase and balcony. The team was professional, on time, and the finished product exceeded our expectations. Our home looks like a luxury showroom now!',
    project: 'Glass Railings',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20young%20woman%20smiling%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20business%20casual%20attire&width=100&height=100&seq=rev002&orientation=squarish',
  },
  {
    name: 'David R.',
    location: 'Las Vegas, NV',
    rating: 5,
    text: 'Got custom mirrors for our gym and they look incredible. The team measured everything perfectly and the installation was clean and fast. Will definitely use Quinolux again for our next project.',
    project: 'Custom Gym Mirrors',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20man%20in%20his%2040s%20smiling%2C%20clean%20white%20background%2C%20confident%20expression%2C%20casual%20shirt&width=100&height=100&seq=rev003&orientation=squarish',
  },
  {
    name: 'Jennifer M.',
    location: 'Spring Valley, NV',
    rating: 5,
    text: 'From the initial quote to the final installation, the entire experience was seamless. They were transparent about pricing, showed up on time, and the frameless shower enclosure is absolutely beautiful.',
    project: 'Shower Enclosure',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20woman%20in%20her%2030s%20smiling%20warmly%2C%20clean%20white%20background%2C%20friendly%20professional%20look&width=100&height=100&seq=rev004&orientation=squarish',
  },
];

const ReviewsPreview = () => {
  return (
    <section className="py-20 md:py-28 bg-[#F8F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-black text-white text-xs font-semibold px-4 py-2 rounded-full mb-5">
            <i className="ri-star-fill text-yellow-400"></i>
            Rated 5.0 on Google
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-black leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            What Our Clients Say
          </h2>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="bg-white rounded-2xl p-7 hover:shadow-md transition-shadow duration-300"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              {/* Quote */}
              <p className="text-gray-700 text-sm leading-relaxed mb-6">&ldquo;{review.text}&rdquo;</p>
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div>
                  <p className="text-black font-semibold text-sm">{review.name}</p>
                  <p className="text-gray-400 text-xs">{review.location} &middot; {review.project}</p>
                </div>
                <div className="ml-auto">
                  <i className="ri-google-fill text-gray-300 text-xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-8 text-center">
          {[
            { num: '500+', label: 'Google Reviews' },
            { num: '5.0', label: 'Average Rating' },
            { num: '98%', label: 'Would Recommend' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <p className="text-4xl font-bold text-black">{stat.num}</p>
              <p className="text-gray-500 text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/reviews" className="inline-flex items-center gap-2 bg-black text-white text-sm font-medium px-8 py-4 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
            Read All Reviews <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ReviewsPreview;
